








































import { Component, Vue, Prop } from 'vue-property-decorator';
import { setRedirectAfterLogin } from '~/utils/redirectAfterLogin';
import WalletCreationModalFlow from '~/components/NewWallet/WalletCreationModalFlow.vue';

@Component({
  components: {
    WalletCreationModalFlow,
  },
  middleware: 'verifyEmail',
})
export default class EmailVerifiedConfirmation extends Vue {
  @Prop({ type: Boolean, default: false }) readonly walletExists!: boolean;

  w3wConnectionEnabled = process.env.w3wConnectionEnabled;
  showWalletCreation = false;

  get newUser() {
    return this.walletExists ? false : this.$route.query.newuser === 'true';
  }

  get walletSetupButtonText() {
    return this.w3wConnectionEnabled
      ? this.$t('components.settings.web3WalletConnections.connectWallet')
      : this.$t(
          'components.emailVerification.emailVerifiedConfirmation.createWallet',
        );
  }

  get instructionsAction() {
    return this.w3wConnectionEnabled
      ? this.$t(
          'components.emailVerification.emailVerifiedConfirmation.connect',
        )
      : this.$t(
          'components.emailVerification.emailVerifiedConfirmation.create',
        );
  }

  get headingText() {
    return this.newUser
      ? this.$t(
          'components.emailVerification.emailVerifiedConfirmation.nearlyThere',
        )
      : this.$t(
          'components.emailVerification.emailVerifiedConfirmation.emailVerified',
        );
  }

  get continueBtnText() {
    return this.newUser
      ? this.$t('components.emailVerification.emailVerifiedConfirmation.skip')
      : this.$t(
          'components.emailVerification.emailVerifiedConfirmation.continueToHome',
        );
  }

  async created() {}

  goTo(route: string) {
    this.$router.push(route);
  }

  async handleWalletSetup() {
    let route = this.w3wConnectionEnabled
      ? '/connect-wallet'
      : '/?createWallet=1';
    // @ts-ignore For some reason it does not know about the token property https://github.com/nuxt-community/auth-module/issues/1338
    if (this.$auth.strategy.token.get() && this.$route.name === 'index') {
      if (this.w3wConnectionEnabled) {
        this.goToConnectWallet(route);
      } else {
        this.showWalletCreation = true;
      }
    } else {
      setRedirectAfterLogin(route);
      await this.$auth.loginWith('auth0', { params: { prompt: 'login' } });
    }
  }

  goToConnectWallet(route: string) {
    if (
      this.$router.currentRoute &&
      this.$router.currentRoute.params &&
      this.$router.currentRoute.params.id
    ) {
      // Sending the item ID allows us to redirect users to purchase page after wallet connection if they are in the process of buying an item
      route = route + '/?item=' + this.$router.currentRoute.params.id;
    }

    this.goTo(route);
  }

  handleSkip() {
    if (this.$route.name === 'index') {
      this.$emit('skip');
    } else {
      return this.$auth.loginWith('auth0', { params: { prompt: 'login' } });
    }
  }
}
